<template>
  <div class="w-100 h-100">
    <dv-border-box-7>
      <div class="h-100">
        <zd-scroll-board style="font-size: 1.65rem;" :config="config" />
      </div>
    </dv-border-box-7>
  </div>
</template>

<script>
import dateFormat from "date-fns/format";
export default {
  name: "lpa-left",
  props: {
    beans: {
      type: Array,
      default: function () {
        return [];
      },
    },
  },
  data() {
    return {
      startCharts: null,
      dataList: this.beans,
      config: {
        startCharts: "",
        header: ["发生日期", "计划完成日期", "问题内容", "来源", "责任人", "问题解析方式"],
        headerBGC: "#018DCE",
        evenRowBGC: "#000D4A",
        rowNum: 6,
        columnWidth: [160, 160, 950, 220, 220, 220],
        data: [],
      },
    };
  },
  watch: {
    beans: {
      handler: function (val, oldVal) {
        this.dataList = val;
        var data = [];
        var now = new Date().setHours(0, 0, 0, 0) - 100;
        for (var i = 0; i < this.dataList.length; i++) {
          var openedDate = this.dataList[i]["openedDate"];
          var customerClosedDate = this.dataList[i]["customerClosedDate"];
          var owner = this.dataList[i]["owner"];
          var description = this.dataList[i]["description"];
          var source = this.dataList[i]["source"];
          var processCategory = this.dataList[i]["processCategory"];
          if (openedDate > 0) {
            openedDate = this.dateFormat(openedDate, "yyyy-MM-dd");
          }
          if (customerClosedDate > 0) {
            customerClosedDate = this.dateFormat(customerClosedDate, "yyyy-MM-dd");
          }

          if (this.dataList[i]["customerClosedDate"] < now) {
            //超时红色
            openedDate = '<span style="color:red;font-size:0.20rem;">' + openedDate + "</span>";
            customerClosedDate = '<span style="color:red;font-size:0.20rem;">' + customerClosedDate + "</span>";
            owner = '<span style="color:red;font-size:0.20rem;">' + owner + "</span>";
            description = '<span style="color:red;font-size:0.20rem;">' + description + "</span>";
            source = '<span style="color:red;font-size:0.20rem;">' + source + "</span>";
            processCategory = '<span style="color:red;font-size:0.20rem;">' + processCategory + "</span>";
          } else {
            //默认
            openedDate = '<span style="font-size:0.20rem;">' + openedDate + "</span>";
            customerClosedDate = '<span style="font-size:0.20rem;">' + customerClosedDate + "</span>";
            owner = '<span style="font-size:0.20rem;">' + owner + "</span>";
            description = '<span style="font-size:0.20rem;">' + description + "</span>";
            source = '<span style="font-size:0.20rem;">' + source + "</span>";
            processCategory = '<span style="font-size:0.20rem;">' + processCategory + "</span>";
          }
          var value = [openedDate, customerClosedDate, description, source, owner, processCategory];
          data.push(value);
        }

        this.config = {
          startCharts: "",
          header: ["发生日期", "计划完成日期", "问题内容", "来源", "责任人", "问题解析方式"],
          headerBGC: "#018DCE",
          evenRowBGC: "#000D4A",
          rowNum: 6,
          columnWidth: [160, 160, 950, 220, 220, 220],
          data: data,
        };
      },
      deep: true,
    },
  },
  mounted() {
    // this.lineEchart();
  },
  methods: {
    dateFormat(uninx) {
      return dateFormat(uninx, "yyyy/MM/dd");
    },
  },
  destroyed() {
    if (this.startCharts) {
      clearInterval(this.startCharts);
    }
  },
};
</script>


// WEBPACK FOOTER //
// src/pages/fr/report/groups/component/issue-list.vue